import {createApp} from 'vue';

require('./bootstrap');

let app = createApp({})


import vSelect from 'vue-select'
app.component('v-select', vSelect)
app.component('select-2-component', require('./components/Select2Component.vue').default);

import moment from 'moment';
app.use(moment);

app.config.globalProperties.$moment = moment
app.config.globalProperties.window = window
app.config.globalProperties.current_user_id = window.current_user_id
app.config.globalProperties.trans = (key) => {
  return _.get(window.trans, key, key);
};

app.component('auction-component', require('./components/auctions/AuctionComponent.vue').default);
app.component('lot-images-component', require('./components/lots/LotImagesComponent').default);
app.component('download-images-component', require('./components/lots/DownloadImagesComponent').default);
app.component('lot-component', require('./components/lots/LotComponent').default);
app.component('fix-price-lot-component', require('./components/lots/FixPriceComponent').default);
app.component('lot-timer-component', require('./components/lots/LotTimerComponent').default);
app.component('main-slider-component', require('./components/MainSliderComponent').default);
app.component('confirm-phone-component', require('./components/ConfirmPhoneComponent').default);

app.component('current-outlet-component', require('./components/CurrentOutletComponent.vue').default);

app.component('change-password-component', require('./components/ChangePasswordComponent.vue').default);
app.component('confirm-receiving-component', require('./components/direct/ConfirmReceivingComponent.vue').default);
app.component('list-invoices-component', require('./components/invoices/ListInvoicesComponent.vue').default);
app.component('list-purchases-component', require('./components/purchases/ListPurchasesComponent.vue').default);
app.component('list-order-deliveries-component', require('./components/order_deliveries/ListOrderDeliveriesComponent.vue').default);
app.component('change-phone-component', require('./components/user/ChangePhoneComponent.vue').default);
app.component('input-phone-component', require('./components/InputPhoneComponent.vue').default);
app.component('varsling-form-component', require('./components/varsling/VarslingFormComponent.vue').default);

import Echo from "laravel-echo"

window.io = require('socket.io-client');
// Have this in case you stop running your laravel echo server
if (typeof io !== 'undefined') {
  window.Echo = new Echo({
    broadcaster: 'socket.io',
    namespace: null,
    host: window.location.hostname + ':' + window.websocket_port,
    authHost: window.location.hostname,
    authEndpoint: 'broadcasting/auth',
  });
}

app.mount("#app")















